import { render, staticRenderFns } from "./Actividad.vue?vue&type=template&id=85ff6820&lang=pug&"
import script from "./Actividad.vue?vue&type=script&lang=js&"
export * from "./Actividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports